import { InputRef } from 'antd';
import { useEffect, useRef } from 'react';

import { Select } from '@style/global-style.app';

import { Input } from '@atom/form/input/input';
import { accountTeamRoleList } from '@form/account-invite/account-invite.options';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';

import { initialAccountTeamForm } from './account-invite.form-initial';
import { accountInviteFormValidation } from './account-invite.form-validation';

export const AccountInviteForm = ({ error, form }: BaseFormInterface) => {
  const inputRef = useRef<InputRef>(null);

  useEffect(() => void inputRef.current?.focus(), []);

  return (
    <Form autoComplete='off' form={form} initialValues={initialAccountTeamForm} layout='vertical' name='team'>
      <Form.Item label='Full Name' name='name' rules={[accountInviteFormValidation]}>
        <Input placeholder='Ex: Joe Doe' ref={inputRef} />
      </Form.Item>
      <Form.Item label='Email' name='email' rules={[accountInviteFormValidation]}>
        <Input placeholder='Ex: joedoe@mail.com' />
      </Form.Item>
      <Form.Item label='Role' name='role' rules={[accountInviteFormValidation]}>
        <Select options={accountTeamRoleList} />
      </Form.Item>
      <FormError error={error} errorField='password' />
    </Form>
  );
};
